<template lang="pug">
  .today
    .todayInner
      .todayRank
        .rankTitle
          header 您本日累积次数
        .rankBadge
          .childCol(v-for="(rank, index) in campaign.currentLeaderBoard")
            .childTitle(:class="index === 0 ? 'rankGold':'rankSilver'")
              p {{rank.name}}
            .childCount
              p(v-if="isInTaskPeriod") {{((rank || {}).rank_player || {}).score || 0}} 个
              p(v-else) 活动已结束
      .todayToal
        .rankTitle
          header 您目前累积投注额
        .rankTotal
          p(v-if="isInTaskPeriod && campaign.currentLeaderBoard") {{formatNumber((campaign.currentLeaderBoard[0].rank_player || {}).turnover)}}
          p(v-else) 活动已结束
</template>
<script>
import numeral from 'numeral'
export default {
  props: ['campaign'],
  methods: {
    formatNumber (val) {
      return numeral(val).format('$0,0.00')
    }
  },
  computed: {
    isInTaskPeriod () {
      return +this.$props.campaign.info.status < 2
    }
  }
}
</script>

<style lang="scss">
@import '~breakpoint-sass/stylesheets/_breakpoint';
@import '../assets/styles/var';
@import '../assets/styles/base/base';
@import '../assets/styles/base/table';

.today {
  width: 100%;
  margin:0 auto;
  background: $ligten-blue;
  border-radius: 10px;
  @include breakpoint($sm-width){
    width: 95%;
  }
  .todayInner {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem 0;
    box-sizing: border-box;
    color: $black;
    font-weight: bold;
    margin-bottom:2rem;
    @include rem(font-size, 1.5rem);
    @include breakpoint(414px) {
      padding: 1rem 0;
    }
    @include breakpoint(1024px){
      flex-direction: row;
      @include rem(font-size, 2rem);
    }
    .rankTitle {
      width: 100%;
      text-align: center;
      margin-bottom: 5px;
      @include rem(font-size, 1.8rem);
      @include breakpoint(1024px){
        @include rem(font-size, 2.4rem);
      }
    }
    .rankTotal {
      color: $blue;
      text-align: center;
      @include rem(font-size, 2rem);
      @include breakpoint(1024px){
        @include rem(font-size, 3rem);
      }
    }
    p {
      margin: 0;
      // font-size: 1.6rem
    }
    .todayRank {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border-bottom: 1px solid $ligten-blue-border;
      margin-bottom: 10px;
      @include breakpoint(1024px){
        border-right: 1px solid $ligten-blue-border;
        border-bottom: 0;
        margin-bottom: 0;
        flex-basis: 65%;
      }
      .rankBadge {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @include breakpoint(568px) {
          flex-direction: row;
        }
        .childCol {
          width: 95%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin: 5px 0;
          @include breakpoint(1024px) {
            flex: 0 0 45%;
          }
          .childTitle {
            height: 36px;
            flex-basis: auto;
            padding-left: 40px;
            box-sizing: border-box;
            position: relative;
            margin: 0 3%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            @include breakpoint(568px) {
              padding-left: 35px;
            }
            @include breakpoint(1024px) {
              margin: 0 auto;
              padding-left: 52px;
            }
            &.rankGold:before {
              content: '';
              width: 36px;
              height: 36px;
              display: block;
              position: absolute;
              left: 0;
              top: calc(50% - 18px);
              background: url('../assets/images/award_g.png') no-repeat center center;
              background-size: cover;
              @include breakpoint(568px){
                width: 32px;
                height: 32px;
                top: calc(50% - 16px);
              }
              @include breakpoint(1024px){
                width: 44px;
                height: 44px;
                top: calc(50% - 22px);
              }
            }
            &.rankSilver:before {
              content: '';
              width: 36px;
              height: 36px;
              display: block;
              position: absolute;
              left: 0;
              top: calc(50% - 18px);
              background: url('../assets/images/award_s.png') no-repeat center center;
              background-size: cover;
              @include breakpoint(568px){
                width: 32px;
                height: 32px;
                top: calc(50% - 16px);
              }
              @include breakpoint(1024px){
                width: 44px;
                height: 44px;
                top: calc(50% - 22px);
              }
            }
          }
          .childCount {
            height: 36px;
            flex-basis: auto;
            margin: 0 3%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
    .todayToal {
      @include breakpoint(1024px){
        flex-basis: 35%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/awardBox.vue